import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProducSpecsDoubleColumn, ProducSpecsSingleColumn, TABLE_SPEC_TYPE } from './core/product-specifications.model';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ProductSpecificationsService } from './core/product-specifications.service';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';

@Component({
  selector: 'product-specifications',
  templateUrl: './product-specifications.component.html',
  styleUrl: './product-specifications.component.scss',
  standalone: false,
})
export class ProductSpecificationsComponent implements OnInit, OnDestroy {
  TABLE_SPEC_TYPE = TABLE_SPEC_TYPE;

  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  tables$ = new BehaviorSubject<(ProducSpecsSingleColumn | ProducSpecsDoubleColumn)[]>([]);

  currentTable$ = new BehaviorSubject<string | undefined>(undefined);
  subscription = new Subscription();

  constructor(
    private productSpecificationsService: ProductSpecificationsService,
    private currentProductService: CurrentProductService,
  ) {}

  ngOnInit(): void {
    this.createTabs();
    this.initTabs();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  createTabs() {
    this.subscription.add(
      this.product$.subscribe(async product => {
        const tables: (ProducSpecsSingleColumn | ProducSpecsDoubleColumn)[] = [];

        // Product Classifications Tables
        (product?.classifications || []).forEach(classification => {
          const table: ProducSpecsDoubleColumn =
            this.productSpecificationsService.normalizeProductClassifications(classification);

          table.attributes.length && tables.push(table);
        });

        // Load Curve Table
        const loadCurveTable = await this.productSpecificationsService.normalizeLoadCurveClassification(
          product?.customClassifications?.loadCurve || [],
        );

        loadCurveTable.attributes.length && tables.push(loadCurveTable);

        // Speed Caracteristics
        const speedCaracteristics = await this.productSpecificationsService.normalizeSpeedCurveClassification(
          product?.customClassifications?.speedCurve || [],
        );

        speedCaracteristics.attributes.length && tables.push(speedCaracteristics);

        // tables.push(nameplateMock);
        // tables.push(technicalMock);
        // tables.push(speedCaracteristicsMock);
        // tables.push(loadCaracteristicsMock);

        this.tables$.next(tables);
      }),
    );
  }

  initTabs() {
    this.subscription.add(
      this.tables$.subscribe(tables => {
        tables[0]?.uid && this.setTab(tables[0].uid);
      }),
    );
  }

  setTab(tab: string) {
    this.currentTable$.next(tab);
  }

  identifyTable(table: ProducSpecsSingleColumn | ProducSpecsDoubleColumn) {
    return this.productSpecificationsService.identifySpecs(table);
  }
}
